




















































































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { MasterDataApi, ProjectApi, UnitApi, PlanningPJApi, CRNameApi, QCInspectionApi, EmployeeApi } from '@/api'
import { IPlanningPJProvider, IPlanningPJProviderRequest } from '@/interface/IPlanningPJProvider'
import { ValidateTransferSaveForPJ } from '@/resource/planning-cr/TransferPlanningValidate'
//component
import DropDownProject from "@/components/common/combobox/DropDownProject.vue"
import DropDownManageUnit from "@/components/common/combobox/DropDownManageUnit.vue"
import DatePickerFromTo from "@/components/common/date-picker/DatePickerFromTo.vue"
import DatePickerFromToDisabled from "@/components/common/date-picker/DatePickerFromToDisabled.vue"
import DropDownFixData from "@/components/common/combobox/DropDownFixData.vue"
import DatePicker from "@/components/common/date-picker/DatePicker.vue"
import Notification from "@/components/common/notification/Notification.vue"
import DataTableTransferPlanning from "@/components/planning-pj/datatable/DataTableTransferPlanning.vue"
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import { AuthenticateApi } from "@/api"
import { namespace } from 'vuex-class'


const Auth = namespace('authentication')

import { ExportExcel } from "@/resource/planning-pj/ExportExcel"

//constants
import { 
        SentRoomCRTypeLists,
        TransferTypeLists,
        RecieveTypeLists,
        CheckingTypeLists,
        RecieveUpdateColumnTypeLists
    } from "@/constants/DropDownData"

@Component({
    components: { 
        'common-combobox-dropdownproject': DropDownProject,
        'common-combobox-dropdownmanageunit': DropDownManageUnit,
        'common-date-picker-dropdownfixdata': DropDownFixData,
        'common-date-picker-datepickerfromto': DatePickerFromTo,
        'common-date-picker-datepicker': DatePicker,
        'common-notification-notification': Notification,
        DatePickerFromToDisabled,
        DataTableTransferPlanning,
        BreadcrumbsPath
    }
})
export default class TransferPlanningPJ extends Vue { 
    panel: number = 0
    loading: boolean = false
    dialogConfirm: boolean = false
    isDataTableTransferPlanning: any = true
    projectLists: any = []

    permissionSave = false

    jsonForm = {
        projectName: "",
        projectId: "",
        productType: "",
        unitSelectType: "unitAll",
        unitSelected: [],
        unitFrom: "",
        unitTo: "",
        contractDateFrom: "",
        contractDateTo: "",
        contractTransferDateFrom: "",
        contractTransferDateTo: "",
        commitDateFrom: "",
        commitDateTo: "",
        finishForInspectionDateFrom: "",
        finishForInspectionDateTo: "",
        crPlanDateFrom: "",
        crPlanDateTo: "",
        transferPlanDateFrom: "",
        transferPlanDateTo: "",
        finalTransferDateFrom: "",
        finalTransferDateTo: "",
        customerInspection1DateFrom: "",
        customerInspection1DateTo: "",
        flagSentRoomCR: "",
        flagTransfer: "",
        transferDateFrom: "",
        transferDateTo: "",
        recieveType: "",
        recieveDateFrom: "",
        recieveDateTo: "",
        checkingType: "",
        csAssign: "",
        statusSold: ["Sold", "Unsold"],
    } as any

    isCcolumnQC = false

    jsonSearch = { 
        projectName: "",
        projectId: 0,
        unitSelectType: "unitAll",
        unitSelected: [],
        unitFrom: "",
        unitTo: "",
        contractDateFrom: "",
        contractDateTo: "",
        contractTransferDateFrom: "",
        contractTransferDateTo: "",
        commitDateFrom: "",
        commitDateTo: "",
        finishForInspectionDateFrom: "",
        finishForInspectionDateTo: "",
        crPlanDateFrom: "",
        crPlanDateTo: "",
        transferPlanDateFrom: "",
        transferPlanDateTo: "",
        finalTransferDateFrom: "",
        finalTransferDateTo: "",
        customerInspection1DateFrom: "",
        customerInspection1DateTo: "",
        flagTransfer: "",
        transferDateFrom: "",
        transferDateTo: "",
        flagSentRoomCR: "",
        recieveType: "",
        recieveDateFrom: "",
        recieveDateTo: "",
        checkingType: "",
        crId: "",
        statusSold: ["Sold", "Unsold"],
    }

    flagSentRoomCRItemData = SentRoomCRTypeLists
    transferItemData = TransferTypeLists
    recieveTypeItemData = RecieveTypeLists
    checkingTypeItemData = CheckingTypeLists

    recieveFormUpdateAllItemData = RecieveUpdateColumnTypeLists
    typeDateUpdateColumn = [
        { id: 1 , name: 'วันที่ CR นัดได้', value: 'cr' },
        { id: 2 , name: 'วันที่ ลูกค้าเข้าตรวจจริง', value: 'customer' },
        { id: 3 , name: 'Plan PJ พร้อมให้เข้าตรวจ', value: 'planPj' },
    ]
    jsonUpdateColumn: any = {
        rdoSelectInspection: "1",
        typeUpdateDateColumnValue: "",
        datePickerUpdateColumn: "",
        recieveFormUpdateColumn: ""
    }

    masterTransferPlanType = [] as any
    masterInspectionTransfer = [] as any
    masterPjDivision = [] as any
    crNameItemData = [] as any
    unitLists = [] as any

    @Auth.State('auth') auth!: any

    @Watch("jsonForm.projectId")
    async onProjectIdChange(val: string, oldVal: string) {
        this.loading = true
        if (val === undefined) {
            this.loading = false
            return 
        }

        let crNameItemData = await CRNameApi.GetCRNamePJByProjectId(val)
        if (crNameItemData!.length > 0 && crNameItemData != undefined) {
            this.crNameItemData = crNameItemData.map((x, index) => ({ id: index, name: x.name, value: x.id , active: x.active}))
        }

        if (val === undefined) {
            this.openNotification("กรุณากรอกชื่อโครงการให้ถูกต้อง", "warning")
            this.loading = false
            return 
        }
        this.unitLists = await UnitApi.GetUnitListsByProjectId(val)

        const refContractDateFromTo = this.$refs.refContractDateFromTo as DatePickerFromTo
        refContractDateFromTo.clear()
        const refContractTransferDateFromTo = this.$refs.refContractTransferDateFromTo as DatePickerFromTo
        refContractTransferDateFromTo.clear()
        const refCommitDateFromTo = this.$refs.refCommitDateFromTo as DatePickerFromTo
        refCommitDateFromTo.clear()
        const refFinishForInspectionDateFromTo = this.$refs.refFinishForInspectionDateFromTo as DatePickerFromTo
        refFinishForInspectionDateFromTo.clear()
        const refCRPlanDateFromTo = this.$refs.refCRPlanDateFromTo as DatePickerFromTo
        refCRPlanDateFromTo.clear()
        const refTransferPlanDateFromTo = this.$refs.refTransferPlanDateFromTo as DatePickerFromTo
        refTransferPlanDateFromTo.clear()
        const refFinalTransferDateFromTo = this.$refs.refFinalTransferDateFromTo as DatePickerFromTo
        refFinalTransferDateFromTo.clear()
        const refCustomerInspection1DateFromTo = this.$refs.refCustomerInspection1DateFromTo as DatePickerFromTo
        refCustomerInspection1DateFromTo.clear()
        const refFlagSentRoomCR = this.$refs.refFlagSentRoomCR as DropDownFixData
        refFlagSentRoomCR.clear()
        const refFlagTransfer = this.$refs.refFlagTransfer as DropDownFixData
        refFlagTransfer.clear()
        const refCheckingType = this.$refs.refCheckingType as DropDownFixData
        refCheckingType.clear()
        const refCSAssign = this.$refs.refCSAssign as DropDownFixData
        refCSAssign.clear()
        const refTypeUpdateDateColumnValue = this.$refs.refTypeUpdateDateColumnValue as DropDownFixData
        refTypeUpdateDateColumnValue.clear()
        const refRecieveFormUpdateColumn = this.$refs.refRecieveFormUpdateColumn as DropDownFixData
        refRecieveFormUpdateColumn.clear()
        this.loading = false
    }

    mounted () {
        this.init()
        this.setMasterData()
       
    }

    async init () {
        this.loading = true

        try {

            const getUserInfo = await AuthenticateApi.GetUserInfo()
            const hasMatchingPermission = getUserInfo?.permission.filter((filter) => 
                filter.profileCode === "TFP-03" || filter.profileCode === "TFP-04"
                );

            var hasSavePermission = getUserInfo?.permission.filter((x => x.profileCode === "TFP-04" ));
            if (hasSavePermission && hasSavePermission?.length > 0) {
                this.permissionSave = true;
            }

            if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
                localStorage.clear()
                window.location.reload()
            }

            this.projectLists = await ProjectApi.GetProjectLists()
            this.loading = false
        } catch (error: any) {
            this.openNotification(`${error.message}`, "warning")
            this.loading = false
        }
    }

    async setUnitLists (projectId: string) {
        this.loading = true
        try {
            const unitLists = await UnitApi.GetUnitListsByProjectId(projectId)
            this.loading = false
            return unitLists
        } catch (error: any) {
            this.openNotification(`${error.message}`, "warning")
            this.loading = false
        }
    }

    async btnSave () {
        this.loading = true
        const refDataTableTransferPlanning = this.$refs.refDataTableTransferPlanning as DataTableTransferPlanning
        const unitSelected: IPlanningPJProvider[] = refDataTableTransferPlanning.saveTransfer()
        if (unitSelected.length <= 0) {
            this.openNotification(`กรุณาเลือกยูนิตที่ต้องการบันทึก`, "warning")
            this.loading = false
            return
        }

        const validate = ValidateTransferSaveForPJ(unitSelected)
        if (validate.status === false) {
            this.openNotification(validate.msg, "warning")
            this.loading = false
            return
        }

        try {
            const jsonRequest: any[] = this.setJsonRequestSaveTransfer(unitSelected)

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "BtnSave",
                page: "TransferPlaningPJ",
                json_data: JSON.stringify(jsonRequest),
                created_by: this.auth.username,
                };

            PlanningPJApi.addLog(logModel)

            const result = await PlanningPJApi.save(jsonRequest)
            if (result === "Updated") {

            // refresh after save
            const getUnitIdUpdated = jsonRequest.map(m => (m.unitId.toString()))
            let planningPJApiSearchData: PlanningPJApi.ISearch[] = await PlanningPJApi.Search(this.setJsonRequestRefreshSave(this.jsonSearch.projectId, getUnitIdUpdated))

            if (this.isCcolumnQC) {
                const qc = await this.qcInspectionColumn(planningPJApiSearchData, this.jsonSearch.unitSelectType)
                if (qc.status === "success") planningPJApiSearchData = qc.planningPJApiData
                if (qc.status === "error") {
                    this.openNotification(`ไม่สามารถแสดงข้อมูล คะแนน QC ครั้งล่าสุด ได้กรุณาลองอีกครั้ง`, "warning")
                    this.isCcolumnQC = false
                }
            }
                refDataTableTransferPlanning.refreshDataTable(this.setJsonDataTable(planningPJApiSearchData))
                refDataTableTransferPlanning.setSelectedByUnitId(getUnitIdUpdated)
                const totalUpdated = planningPJApiSearchData.length
                this.openNotification(`อัพเดทรายการสำเร็จ ${totalUpdated} ยูนิต`, "success")
                this.loading = false
                return
            }
            if (result !== "") {
                this.openNotification(`${result}`, "warning")
                this.loading = false
                return
            }
            this.openNotification(`ไม่สามารถบันทึกข้อมูลได้ กรุณาลองอีกครั้ง`, "warning")
            this.loading = false
        } catch {
            this.openNotification(`ไม่สามารถบันทึกข้อมูลได้ กรุณาลองอีกครั้ง`, "error")
            this.loading = false
        }
    }

    async btnSearch () {
        this.loading = true

        if (this.validateFrom()) return

        try {
            let planningPJApiSearchData: PlanningPJApi.ISearch[] = await PlanningPJApi.Search(this.jsonSearch)

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSearchPJ Data Found : " + planningPJApiSearchData.length.toString() + " Records",
                page: "TransferPlaningPJ",
                json_data: JSON.stringify(this.jsonSearch),
                created_by: this.auth.username,
                };

            PlanningPJApi.addLog(logModel)

            if (planningPJApiSearchData.length > 0) {

                if (this.isCcolumnQC) {
                    const qc = await this.qcInspectionColumn(planningPJApiSearchData, this.jsonSearch.unitSelectType)
                    if (qc.status === "success") planningPJApiSearchData = qc.planningPJApiData
                    if (qc.status === "error") {
                        this.openNotification(`ไม่สามารถแสดงข้อมูล คะแนน QC ครั้งล่าสุด ได้กรุณาลองอีกครั้ง`, "warning")
                        this.isCcolumnQC = false
                    }
                }

                this.isDataTableTransferPlanning = true
                this.loading = false
            } else {
                this.openNotification(`ไม่พบข้อมูลที่ค้นหา`, "warning")
                this.isDataTableTransferPlanning = null
                this.loading = false
            }

            const refDataTableTransferPlanning = this.$refs.refDataTableTransferPlanning as DataTableTransferPlanning
            refDataTableTransferPlanning.setDataTable(this.setJsonDataTable(planningPJApiSearchData), this.isCcolumnQC)
            refDataTableTransferPlanning.clearSelected()

            if (['unitSelected', 'unitRange'].includes(this.jsonSearch.unitSelectType)) refDataTableTransferPlanning.setSelectedAll()
                
            this.loading = false
        } catch (error: any) {
            this.openNotification(`${error.message}`, "error")
            this.loading = false
        }
        
    }

    btnUpdateAllDate () {
        const { typeUpdateDateColumnValue, datePickerUpdateColumn } = this.jsonUpdateColumn
        if (typeUpdateDateColumnValue === "" || datePickerUpdateColumn == "") {
            this.openNotification(`กรุณากรอกข้อมูลให้ครบ`, "warning")
            return
        }

        let columnName = ""
        if (typeUpdateDateColumnValue === "cr") columnName = `inspection${this.jsonUpdateColumn.rdoSelectInspection}PlanCRDate`
        if (typeUpdateDateColumnValue === "customer") columnName = `inspection${this.jsonUpdateColumn.rdoSelectInspection}CustomerDate`
        if (typeUpdateDateColumnValue === "planPj") columnName = `inspection${this.jsonUpdateColumn.rdoSelectInspection}PlanPJDate`

        const refDataTableTransferPlanning = this.$refs.refDataTableTransferPlanning as any
        refDataTableTransferPlanning.updateColumnsDataTable(columnName, datePickerUpdateColumn)

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnUpdateAllDate",
                page: "TransferPlaningPJ",
                json_data: JSON.stringify(this.jsonUpdateColumn),
                created_by: this.auth.username,
                };

             PlanningPJApi.addLog(logModel)
    }
    btnUpdateAllRecieve () {
        const { recieveFormUpdateColumn } = this.jsonUpdateColumn
        let columnName = `inspection${this.jsonUpdateColumn.rdoSelectInspection}TypeID`
        const refDataTableTransferPlanning = this.$refs.refDataTableTransferPlanning as any
        refDataTableTransferPlanning.updateColumnsDataTable(columnName, recieveFormUpdateColumn)

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnUpdateAllRecieve",
                page: "TransferPlaningPJ",
                json_data: JSON.stringify(this.jsonUpdateColumn),
                created_by: this.auth.username,
                };

             PlanningPJApi.addLog(logModel)

    }

    async setMasterData () {
        const masterTransferPlanType = await MasterDataApi.GetMasterDataVlookupByType('TransferPlan_Type')
        const masterTransferPlanTypeEmpty = [{ id: 0, name: "เข้าตรวจปกติ(ตรวจก่อนทำรายการโอน)" }]
        Array.prototype.push.apply(masterTransferPlanTypeEmpty, masterTransferPlanType.map(m => ({ id: m.id, name: m.descriptionTH })))
        this.masterTransferPlanType = masterTransferPlanTypeEmpty

        const masterInspectionTransfer = await MasterDataApi.GetMasterDataVlookupByType("InspectionTransfer")
        const masterInspectionTransferEmpty = [{ id: 0, name: "" }]
        Array.prototype.push.apply(masterInspectionTransferEmpty, masterInspectionTransfer.map(m => ({ id: m.id, name: m.descriptionTH })))
        this.masterInspectionTransfer = masterInspectionTransferEmpty
        
        const pjDivision = await EmployeeApi.GetEmployeeData()
        const masterPjDivisionEmpty = [{ id: 0, name: "" }]
        Array.prototype.push.apply(masterPjDivisionEmpty, pjDivision.map(m => ({ id: m.empCode, name: m.empFullName })))
        this.masterPjDivision = masterPjDivisionEmpty
    }

    setJsonSearch () {
        this.jsonSearch.projectName = this.projectLists.filter((x: any) => x.id === this.jsonForm.projectId)[0].name
        this.jsonSearch.projectId = parseInt(this.jsonForm.projectId)
        this.jsonSearch.unitSelectType = this.jsonForm.unitSelectType
        this.jsonSearch.unitSelected = this.jsonForm.unitSelected
        this.jsonSearch.unitFrom = this.jsonForm.unitFrom
        this.jsonSearch.unitTo = this.jsonForm.unitTo
        // วันที่ทำสัญญา
        this.jsonSearch.contractDateFrom = this.jsonForm.contractDateFrom
        this.jsonSearch.contractDateTo = this.jsonForm.contractDateTo
        // วันที่โอนตามสัญญา
        this.jsonSearch.contractTransferDateFrom = this.jsonForm.contractTransferDateFrom
        this.jsonSearch.contractTransferDateTo = this.jsonForm.contractTransferDateTo
        // วันที่นัดตรวจ
        this.jsonSearch.commitDateFrom = this.jsonForm.commitDateFrom
        this.jsonSearch.commitDateTo = this.jsonForm.commitDateTo
        // วันที่เก็บงานเสร็จพร้อมตรวจ
        this.jsonSearch.finishForInspectionDateFrom = this.jsonForm.finishForInspectionDateFrom
        this.jsonSearch.finishForInspectionDateTo = this.jsonForm.finishForInspectionDateTo
        // CR Plan วันโอน
        this.jsonSearch.crPlanDateFrom = this.jsonForm.crPlanDateFrom
        this.jsonSearch.crPlanDateTo = this.jsonForm.crPlanDateTo
        // วันที่นัดโอน
        this.jsonSearch.transferPlanDateFrom = this.jsonForm.transferPlanDateFrom
        this.jsonSearch.transferPlanDateTo = this.jsonForm.transferPlanDateTo
        // สรุปวันโอน(Plan+Actual)
        this.jsonSearch.finalTransferDateFrom = this.jsonForm.finalTransferDateFrom
        this.jsonSearch.finalTransferDateTo = this.jsonForm.finalTransferDateTo
        // วันที่ลูกค้าเข้าตรวจ 1
        this.jsonSearch.customerInspection1DateFrom = this.jsonForm.customerInspection1DateFrom
        this.jsonSearch.customerInspection1DateTo = this.jsonForm.customerInspection1DateTo
        // การส่งห้องให้ CR
        this.jsonSearch.flagSentRoomCR = this.jsonForm.flagSentRoomCR
        // การรับมอบ
        this.jsonSearch.recieveType = this.jsonForm.recieveType
        this.jsonSearch.recieveDateFrom = this.jsonForm.recieveType != "208,0" ? this.jsonForm.recieveDateFrom : ""
        this.jsonSearch.recieveDateTo = this.jsonForm.recieveType != "208,0" ? this.jsonForm.recieveDateTo : ""
        // ประเภทการเข้าตรวจ
        this.jsonSearch.checkingType = this.jsonForm.checkingType
        this.jsonSearch.crId = `${this.jsonForm.csAssign}`
        // การโอน
        this.jsonSearch.flagTransfer = this.jsonForm.flagTransfer
        this.jsonSearch.transferDateFrom = this.jsonForm.flagTransfer != "N" ? this.jsonForm.transferDateFrom : ""
        this.jsonSearch.transferDateTo = this.jsonForm.flagTransfer != "N" ? this.jsonForm.transferDateTo : ""
        // สถานะการขาย
        this.jsonSearch.statusSold = this.jsonForm.statusSold
    }

    setJsonRequestRefreshSave (projectId: number, unitSelected: number[]) {
        return { 
            projectName: "",
            projectId: projectId,
            unitSelectType: "UNITSELECTED",
            unitSelected: unitSelected,
            unitFrom: "",
            unitTo: "",
            contractDateFrom: "",
            contractDateTo: "",
            contractTransferDateFrom: "",
            contractTransferDateTo: "",
            commitDateFrom: "",
            commitDateTo: "",
            finishForInspectionDateFrom: "",
            finishForInspectionDateTo: "",
            crPlanDateFrom: "",
            crPlanDateTo: "",
            transferPlanDateFrom: "",
            transferPlanDateTo: "",
            finalTransferDateFrom: "",
            finalTransferDateTo: "",
            customerInspection1DateFrom: "",
            customerInspection1DateTo: "",
            flagTransfer: "",
            transferDateFrom: "",
            transferDateTo: "",
            flagSentRoomCR: "",
            recieveType: "",
            recieveDateFrom: "",
            recieveDateTo: "",
            checkingType: "",
            crId: "",
            statusSold: ["Sold", "Unsold"],
        }
    }

    setJsonRequestSaveTransfer (jsonData: IPlanningPJProvider[]) {
        const newJsonData = jsonData.map(m => {
            const jsonRequest = {} as IPlanningPJProviderRequest
            jsonRequest.unitId = m.unitId
            jsonRequest.unitCode = m.unitCode
            jsonRequest.bookingId = m.bookingId,
            jsonRequest.productType = this.jsonForm.productType
            jsonRequest.signId = m.signId
            jsonRequest.transferId = m.transferId
            jsonRequest.prospectId = m.prospectId
            jsonRequest.planPJAfterTransferDate = m.planPJAfterTransferDate.replaceAll("-", "")
            jsonRequest.inspectionAfterTransferDate = m.inspectionAfterTransferDate.replaceAll("-", "")
            jsonRequest.inspection1Id = m.inspection1Id
            jsonRequest.inspection1TypeID = m.inspection1TypeID
            jsonRequest.inspection1FinishPJDate = m.inspection1FinishPJDate.replaceAll("-", "")
            jsonRequest.inspection1FinishPJDateOriginal = m.inspection1FinishPJDateOriginal.replaceAll("-", "")
            jsonRequest.inspection1CustomerDate = m.inspection1CustomerDate.replaceAll("-", "")
            jsonRequest.inspection1PlanPJDate = m.inspection1PlanPJDate.replaceAll("-", "")
            jsonRequest.inspection1PlanCRDate = m.inspection1PlanCRDate.replaceAll("-", "")
            jsonRequest.inspection1PlanCRDateOriginal = m.inspection1PlanCRDateOriginal.replaceAll("-", "")
            jsonRequest.inspection1PlanCRTime = m.inspection1PlanCRTime
            jsonRequest.inspection2Id = m.inspection2Id
            jsonRequest.inspection2TypeID = m.inspection2TypeID
            jsonRequest.inspection2FinishPJDate = m.inspection2FinishPJDate.replaceAll("-", "")
            jsonRequest.inspection2FinishPJDateOriginal = m.inspection2FinishPJDateOriginal.replaceAll("-", "")
            jsonRequest.inspection2CustomerDate = m.inspection2CustomerDate.replaceAll("-", "")
            jsonRequest.inspection2PlanPJDate = m.inspection2PlanPJDate.replaceAll("-", "")
            jsonRequest.inspection2PlanCRDate = m.inspection2PlanCRDate.replaceAll("-", "")
            jsonRequest.inspection2PlanCRDateOriginal = m.inspection2PlanCRDateOriginal.replaceAll("-", "")
            jsonRequest.inspection2PlanCRTime = m.inspection2PlanCRTime
            jsonRequest.inspection3Id = m.inspection3Id
            jsonRequest.inspection3TypeID = m.inspection3TypeID
            jsonRequest.inspection3FinishPJDate = m.inspection3FinishPJDate.replaceAll("-", "")
            jsonRequest.inspection3FinishPJDateOriginal = m.inspection3FinishPJDateOriginal.replaceAll("-", "")
            jsonRequest.inspection3CustomerDate = m.inspection3CustomerDate.replaceAll("-", "")
            jsonRequest.inspection3PlanPJDate = m.inspection3PlanPJDate.replaceAll("-", "")
            jsonRequest.inspection3PlanCRDate = m.inspection3PlanCRDate.replaceAll("-", "")
            jsonRequest.inspection3PlanCRDateOriginal = m.inspection3PlanCRDateOriginal.replaceAll("-", "")
            jsonRequest.inspection3PlanCRTime = m.inspection3PlanCRTime
            jsonRequest.inspection4Id = m.inspection4Id
            jsonRequest.inspection4TypeID = m.inspection4TypeID
            jsonRequest.inspection4FinishPJDate = m.inspection4FinishPJDate.replaceAll("-", "")
            jsonRequest.inspection4FinishPJDateOriginal = m.inspection4FinishPJDateOriginal.replaceAll("-", "")
            jsonRequest.inspection4CustomerDate = m.inspection4CustomerDate.replaceAll("-", "")
            jsonRequest.inspection4PlanPJDate = m.inspection4PlanPJDate.replaceAll("-", "")
            jsonRequest.inspection4PlanCRDate = m.inspection4PlanCRDate.replaceAll("-", "")
            jsonRequest.inspection4PlanCRDateOriginal = m.inspection4PlanCRDateOriginal.replaceAll("-", "")
            jsonRequest.inspection4PlanCRTime = m.inspection4PlanCRTime
            jsonRequest.crNote = m.crNote
            jsonRequest.pjNote = m.pjNote
            jsonRequest.letterPlanforCR = m.letterPlanforCROriginal
            jsonRequest.letterPlanforCROriginal = m.letterPlanforCR
            jsonRequest.transferPlanTypeId = m.transferPlanTypeId
            jsonRequest.flagInspectorContractor = m.flagInspectorContractor
            jsonRequest.inspectorName = m.flagInspectorContractor ? m.inspectorName : ""
            jsonRequest.pjCode = m.pjCode.toLocaleString() == "" ? 0 : Number(m.pjCode)
            return jsonRequest
        })
        return newJsonData
    }

    setJsonDataTable (jsonData: any[]) {
        jsonData.map(m => {
            if (m.csPlanDate != "") m.csPlanDate = dayjs(m.csPlanDate).format("DD/MM/YYYY")
            if (m.finalActualDate != "") m.finalActualDate = dayjs(m.finalActualDate).format("DD/MM/YYYY")
            if (m.transferActDate != "") m.transferActDate = dayjs(m.transferActDate).format("DD/MM/YYYY")
            if (m.customerTransferReal != "") m.customerTransferReal = dayjs(m.customerTransferReal).format("DD/MM/YYYY")
            m.areaValue = m.areaValue == '0' ? "" : m.areaValue.toLocaleString()
            if (m.contractUnitPrice != '0') m.contractUnitPrice = m.contractUnitPrice.toLocaleString()
            if (m.netPrice != '0') m.netPrice = m.netPrice.toLocaleString()
            if (m.inspection1PlanPJDate != "") m.inspection1PlanPJDate = dayjs(m.inspection1PlanPJDate).format("YYYY-MM-DD")
            if (m.inspectionAfterTransferDate != "") m.inspectionAfterTransferDate = dayjs(m.inspectionAfterTransferDate).format("YYYY-MM-DD")
            if (m.planPJAfterTransferDate != "") m.planPJAfterTransferDate = dayjs(m.planPJAfterTransferDate).format("YYYY-MM-DD")
            if (m.letterPlanforCR != "") m.letterPlanforCR = dayjs(m.letterPlanforCR).format("YYYY-MM-DD")
            if (m.inspection1PlanPJDate != "") m.inspection1PlanPJDate = dayjs(m.inspection1PlanPJDate).format("YYYY-MM-DD")
            if (m.inspection1FinishPJDate != "") m.inspection1FinishPJDate = dayjs(m.inspection1FinishPJDate).format("YYYY-MM-DD")
            if (m.inspection1PlanCRDate != "") m.inspection1PlanCRDate = dayjs(m.inspection1PlanCRDate).format("YYYY-MM-DD")
            if (m.inspection1CustomerDate != "") m.inspection1CustomerDate = dayjs(m.inspection1CustomerDate).format("YYYY-MM-DD")
            if (m.inspection2PlanPJDate != "") m.inspection2PlanPJDate = dayjs(m.inspection2PlanPJDate).format("YYYY-MM-DD")
            if (m.inspection2FinishPJDate != "") m.inspection2FinishPJDate = dayjs(m.inspection2FinishPJDate).format("YYYY-MM-DD")
            if (m.inspection2PlanCRDate != "") m.inspection2PlanCRDate = dayjs(m.inspection2PlanCRDate).format("YYYY-MM-DD")
            if (m.inspection2CustomerDate != "") m.inspection2CustomerDate = dayjs(m.inspection2CustomerDate).format("YYYY-MM-DD")
            if (m.inspection3PlanPJDate != "") m.inspection3PlanPJDate = dayjs(m.inspection3PlanPJDate).format("YYYY-MM-DD")
            if (m.inspection3FinishPJDate != "") m.inspection3FinishPJDate = dayjs(m.inspection3FinishPJDate).format("YYYY-MM-DD")
            if (m.inspection3PlanCRDate != "") m.inspection3PlanCRDate = dayjs(m.inspection3PlanCRDate).format("YYYY-MM-DD")
            if (m.inspection3CustomerDate != "") m.inspection3CustomerDate = dayjs(m.inspection3CustomerDate).format("YYYY-MM-DD")
            if (m.inspection4PlanPJDate != "") m.inspection4PlanPJDate = dayjs(m.inspection4PlanPJDate).format("YYYY-MM-DD")
            if (m.inspection4FinishPJDate != "") m.inspection4FinishPJDate = dayjs(m.inspection4FinishPJDate).format("YYYY-MM-DD")
            if (m.inspection4PlanCRDate != "") m.inspection4PlanCRDate = dayjs(m.inspection4PlanCRDate).format("YYYY-MM-DD")
            if (m.inspection4CustomerDate != "") m.inspection4CustomerDate = dayjs(m.inspection4CustomerDate).format("YYYY-MM-DD")

            m.finalCRPlanDate = m.finalCRPlanDate == "19000101" ? "" : m.finalCRPlanDate
            m.finalCRPlanDate = m.finalCRPlanDate == "" ? "" : dayjs(m.finalCRPlanDate).format("DD/MM/YYYY")
            m.finalInspection = m.finalInspection == "0" ? "" : m.finalInspection

            m.inspection1PlanCRDateOriginal = m.inspection1PlanCRDate
            m.inspection2PlanCRDateOriginal = m.inspection2PlanCRDate
            m.inspection3PlanCRDateOriginal = m.inspection3PlanCRDate
            m.inspection4PlanCRDateOriginal = m.inspection4PlanCRDate

            m.inspection1FinishPJDateOriginal = m.inspection1FinishPJDate
            m.inspection2FinishPJDateOriginal = m.inspection2FinishPJDate
            m.inspection3FinishPJDateOriginal = m.inspection3FinishPJDate
            m.inspection4FinishPJDateOriginal = m.inspection4FinishPJDate
            m.letterPlanforCROriginal = m.letterPlanforCR
            return m
        })
        return jsonData
    }

    async btnExportExcel () {
        this.loading = true
        
        if (this.validateFrom()) return

        try {

            let planningPJApiSearchData: PlanningPJApi.ISearch[] = await PlanningPJApi.Search(this.jsonSearch)
            if (planningPJApiSearchData.length > 0) {

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnExportExcelPJ Data Found : " + planningPJApiSearchData.length.toString() + " Records",
                page: "TransferPlaningPJ",
                json_data: JSON.stringify(this.jsonSearch),
                created_by: this.auth.username,
                };

             PlanningPJApi.addLog(logModel)

                if (this.isCcolumnQC) {
                    const qc = await this.qcInspectionColumn(planningPJApiSearchData, this.jsonSearch.unitSelectType)
                    if (qc.status === "success") planningPJApiSearchData = qc.planningPJApiData
                    if (qc.status === "error") {
                        this.openNotification(`ไม่สามารถแสดงข้อมูล คะแนน QC ครั้งล่าสุด ได้กรุณาลองอีกครั้ง`, "warning")
                        this.isCcolumnQC = false
                    }
                }

                this.isDataTableTransferPlanning = true
                this.loading = false
            } else {
                this.openNotification(`ไม่พบข้อมูลที่ค้นหา`, "warning")
                this.isDataTableTransferPlanning = null
                this.loading = false
                return
            }
            await ExportExcel(planningPJApiSearchData, {
                masterTransferPlanType: this.masterTransferPlanType,
                masterInspectionTransfer: this.masterInspectionTransfer
            }).then(() => {
                this.loading = false
                this.openNotification(`Export Excel สำรเร็จ`, "success")
            })
        } catch (error: any) {
            this.openNotification(`${error.message}`, "warning")
            this.loading = false
        }
    }

    async qcInspectionColumn (planningPJApiData: PlanningPJApi.ISearch[], unitSelectType: string) {
        try {
            let requestObject = {}
            let unitCodeQcInspection = [] as QCInspectionApi.IGetQCInspection[]
            const projectCode = planningPJApiData[0].unitCode.split('-')[0].trim() ?? ''
            if (unitSelectType === 'unitAll') {
                requestObject = { ProjectCode: projectCode, UnitCode: []}
                unitCodeQcInspection = await QCInspectionApi.GetQCInspection(requestObject) 
            } else {
                unitCodeQcInspection = await QCInspectionApi.GetQCInspection({ projectCode, UnitCode: planningPJApiData.map(p => (p.unitCode.trim())) }) 
            }
            
            const newPlanningPJApiData = planningPJApiData.map((x: any) => {
                let qc = unitCodeQcInspection.filter(q => q.unitCode === x.unitCode)
                if (qc.length > 0) {
                    x.qcInspection = qc[0].qcInspection,
                    x.qcStatus = qc[0].qcStatus
                } else {
                    x.qcInspection = "",
                    x.qcStatus = ""
                }
                return x
            })
           
            return { 
                status: "success",
                planningPJApiData: newPlanningPJApiData
            }
        } catch (error) {
            return { 
                status: "error",
                planningPJApiData: []
            }
        }
        
    }

    validateFrom () {
        if (this.jsonForm.projectId === 0 || this.jsonForm.projectId === "") {
            this.openNotification(`กรุณาเลือกโครงการ`, "warning")
            this.loading = false
            return true
        }

        this.setJsonSearch()
        if (this.jsonSearch.projectId === 0) {
            this.openNotification(`กรุณาเลือกโครงการ`, "warning")
            this.loading = false
            return true
        }

        if (this.jsonSearch.unitSelectType === 'unitSelected') {
            if (this.jsonSearch.unitSelected.length === 0) {
                this.openNotification(`กรุณาระบุยูนิต`, "warning")
                this.loading = false
                return true
            }
        }

        if (this.jsonSearch.unitSelectType === 'unitRange') {
            if (this.jsonSearch.unitFrom === "" || this.jsonSearch.unitTo === "") {
                this.openNotification(`กรุณาระบุยูนิต เริ่มต้น - ยูนิตสิ้นสุด`, "warning")
                this.loading = false
                return true
            }
        }
        return false
    }

    changeState (key: string, value: string) {
        this.jsonForm[key] = value
    }

    changeStateJsonUpdateColumn (key: string, value: string) {
        this.jsonUpdateColumn[key] = value
    }

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotifcation as any
        child.openNotification(text, status)
    }
}
